import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscountsComponent } from './discounts/discounts.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DiscountsComponent]
})
export class DiscountsModule { }
